import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
export const CTASection = () => (
  <section className="editorial-section editorial-final">
    <div className="editorial-container editorial-final-row">
      <div className="editorial-final-heading">
        <p className="course-eyebrow">Каталог курсов</p>
        <h2>Выберите курс<br /><span className="ink-underline">по своей теме</span></h2>
      </div>
      <div className="editorial-final-copy">
        <p>В каталоге есть курсы по дизайну, разработке, видеомонтажу и нейросетям.</p>
        <Link to="/courses" className="fokeev-primary-link">Все курсы <ArrowRight size={18} /></Link>
      </div>
    </div>
  </section>
);
